import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { ChevronRight, FileEdit } from 'lucide-react';
import { OWN_TEXT_IDEA_CODE } from '@masha/shared';
import { api, type SessionsDraftsResponse } from '../lib/api';
import { Badge, Card } from './ui';
import { haptic } from '../lib/tma';

export function DraftsBlock() {
  const navigate = useNavigate();
  const { data, isLoading } = useQuery<SessionsDraftsResponse>({
    queryKey: ['sessions', 'drafts'],
    queryFn: () => api.listDrafts(),
    refetchOnWindowFocus: false,
  });

  if (isLoading) return null;
  if (!data || data.drafts.length === 0) return null;

  return (
    <section className="mb-5">
      <div className="flex items-center gap-2 mb-2">
        <FileEdit size={14} className="text-tg-hint" />
        <h3 className="text-xs font-semibold uppercase tracking-wider text-tg-hint">Продолжить</h3>
      </div>
      <ul className="space-y-2">
        {data.drafts.map((d) => {
          const next = Math.min(d.answered_count + 1, d.idea.questions_count);
          const isReady = d.answered_count >= d.idea.questions_count;
          // Own-text drafts have one screen, so a step counter would mislead.
          const label = isReady
            ? 'Готово к генерации'
            : d.idea.code === OWN_TEXT_IDEA_CODE
              ? 'Черновик'
              : `Шаг ${next} из ${d.idea.questions_count}`;
          return (
            <li key={d.id}>
              <Card
                variant="surface"
                padding="sm"
                interactive
                role="button"
                tabIndex={0}
                onClick={() => {
                  haptic('light');
                  navigate(`/sessions/${d.id}`);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    haptic('light');
                    navigate(`/sessions/${d.id}`);
                  }
                }}
                className="flex items-center justify-between"
              >
                <div className="min-w-0 mr-2">
                  <p className="text-sm font-medium truncate mb-1">{d.idea.title}</p>
                  <Badge tone={isReady ? 'success' : 'brand'}>{label}</Badge>
                </div>
                <ChevronRight size={18} className="text-tg-hint flex-shrink-0" />
              </Card>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
